export const servicesInfo = {
  "app-store-listing": {
    title: "App Store Listing",
    brief:
      "This Package offers complete app store listing services for your training app, from writing optimized descriptions to selecting impactful keywords. We handle everything from app submission to creating eye-catching visuals. Ensure your app gets noticed with a professional, fully managed app store presence.",
    whatyouget: [
      "Custom AppStore listing (iOS)",
      "Custom Google Play Store listing (android)",
      "Custom app icon",
      "Customized app previews for all devices (iOS and android)",
      "Fully managed AppStore and Google Play service",
    ],
    timeline: [
      {
        phase: "Completing the form and payment",
        time: "5 mins",
        upTo: "(Client)",
      },
      {
        phase: "Setting up an apple developer account",
        time: "15 mins (1-4 weeks for apple review)",
        upTo: "(Client)",
      },
      {
        phase: "Apply for DUNS number",
        time: "15 mins (1-4 weeks for DUNS review)",
        upTo: "(Client)",
      },
      {
        phase: "Creating Previews",
        time: "2-4 days",
        upTo: "(MSB/Client)",
      },
      {
        phase: "Submitting the app",
        time: "3-4 hrs",
        upTo: "(MSB)",
      },
      {
        phase: "Approval from Store",
        time: "6-8 working days",
        upTo: "(Store)",
      },
    ],
    requirements: [
      "App Name and Description",
      "Logo",
      "Apple Developer account",
      "Active PUSH, PULL and/or PRESS account",
    ],
    price: "100",
    chips: ["$100 per year paid to Apple for Developer account"],
    link: "https://form.typeform.com/to/RlAlTpBC",
    img: "/img/services/App-Store-Thumbnail.webp",
  },
  "landing-page": {
    title: "Custom Landing Page ",
    brief: [
      "Landing pages eliminate distractions, driving your visitors toward a single, actionable goal.",
      " Unlike traditional websites, our landing pages keep your prospects’ attention exactly where you want it",
    ],
    timeline: [
      {
        phase: "Submit the requirements",
        time: "5 mins",
        upTo: "(Client)",
      },
      {
        phase: "Create Landing Page",
        time: "5-12 days",
        upTo: "(MSB)",
      },
    ],
    requirements: [
      "Branding: Your logo, fonts, and preferred colors",
      "Images(Optional): Any photos or visuals you want to include",
      "Sales Message: A description of what you’re offering",
      "Target Audience: A description of who you’re aiming to reach",
    ],
    whatyouget: [
      "1 High-converting landing page (1 page)",
      "High-quality visuals",
      "Custom Product mock-ups",
      "Custom testimonials/transformations",
      "8 sections",
      "Desktop & mobile",
    ],
    requirementSubline: "To get started, we’ll need the following:",
    price: 499,
    img: "/img/services/Landing page.webp",
    link: "https://form.typeform.com/to/x3GyuxTf",
    previewLink: "https://testfit.my.canva.site/landing-pages",
  },
  "social-media": {
    title: "Social Media Packages",
    brief:
      "Elevate your brand on social media with our custom content packages. Get engaging posts and stories that showcase your services.",
    timeline: [
      {
        phase: "Submit the requirements",
        time: "",
        upTo: "(Client)",
      },
      {
        phase: "Creating carousel posts",
        time: "5-7 days",
        upTo: "(MSB)",
      },
    ],
    requirements: [
      "Branding: Your logo, fonts, and preferred colors",
      "Images (Optional): Any photos or visuals you want to include",
      "Sales Message: A brief description of what you’re offering",
      "Target Audience: A description of who you’re aiming to reach",
    ],
    packages: {
      bronze: [
        "1 Custom Post",
        "1 Story About your services",
        "1 Animated Story",
      ],
      silver: [
        "3 Custom posts about your services",
        "2 stories about your services",
        "2 animated stories",
      ],
      gold: [
        "10 custom social media assets",
        "Priority turnaround time",
        "Unlimited revisions included",
      ],
    },
    requirementSubline: "To get started, we’ll need the following:",
    price: "150 - $400",

    link: "https://form.typeform.com/to/TmZ3FVTj",
    img: "/img/services/Social-Media.webp",
    previewLink: "https://testfit.my.canva.site/social-media-portfolio",
  },
  "app-icon": {
    title: "Custom App Icon",
    brief: [
      "An app icon is the small image that represents your app on mobile devices, making it instantly recognizable to users.",
      `Once you reach 10 active users, we’ll add this for free! Go to settings > branding and click "request now" to start this process.`,
      "If you'd like to get your branded icon sooner (before 10 clients), it’s available for a one-time fee of $100. Elevate your app’s look with a custom, professional icon that reflects your brand and strengthens your app’s identity.",
    ],
    timeline: [
      {
        phase: "Submit the requirements and payment",
        time: "5 mins",
        upTo: "(Client)",
      },
      {
        phase: "App Icon design and release",
        time: "1-2 weeks",
        upTo: "(MSB)",
      },
    ],
    whatyouget: ["A custom app icon for both the iOS and android Training App"],
    requirements: ["Submit your brand logo", "Provide the background color"],
    requirementSubline: "To get started, we’ll need the following:",
    img: "/img/services/App-icons.webp",
    price: 100,
    footer: {
      text: "Already have a custom app icon, and want to update it to new one?",
      link: "https://form.typeform.com/to/Fm3TuJOF",
    },
    link: "https://form.typeform.com/to/u81PIPiM",
  },
  thumbnails: {
    title: "Program Thumbnail Covers",
    brief: [
      "Program thumbnail covers are essential for showcasing each workout program. A visually appealing thumbnail that highlights key program details can attract visitors and encourage them to choose your program.",
      "These covers typically feature an image that represents the program, along with the program name and duration.",
    ],
    timeline: [
      {
        phase: "Submit the requirements",
        time: "",
        upTo: "(Client)",
      },
      {
        phase: "Creating Thumbnails",
        time: "3-5 days",
        upTo: "(MSB)",
      },
    ],
    requirements: [
      "Submit images for each thumbnail. Alternatively, we can use royalty-free stock images.",
      "Provide preferred colors.",
      "Include your logo/branding.",
      "Supply program details (name and duration)",
    ],
    img: "/img/services/Thumbnails.webp",
    price: "75 - $200",
    previewLink: "https://testfit.my.canva.site/thumbnail-portfolio",
    packages: {
      list: [
        "5 for $75",
        "10 for $100",
        "15 for $130",
        "20 for $150",
        "25 for $200",
      ],
    },
    link: "https://form.typeform.com/to/luwRggAY",
  },
  "program-quiz": {
    title: "Program Recommendation Quiz",
    brief:
      "Prompt new subscribers to fill out a questionnaire when they first access the app. Based on their unique responses, the questionnaire will recommed a program tailored for their needs which they can start just with the tap of a button",
    timeline: [
      {
        phase: "Submit the requirements",
        time: "",
        upTo: "(Client)",
      },
      {
        phase: "Program recommendation quiz",
        time: "5-7 days",
        upTo: "(MSB)",
      },
    ],
    requirements: [
      "After payment submission, you’ll receive a form to fill out.",
      {
        title: "This form includes:",
        items: [
          "The specific questions the coach wants to ask.",
          "The outcomes, which refer to the programs that will be recommended based on the answers.",
        ],
      },
    ],
    price: 199,
    img: "/img/services/Program-Recommendation-Quiz.webp",
    link: "https://form.typeform.com/to/vvcUEAtf",
  },
  "animated-storefront": {
    title: "Animated Storefront",
    brief:
      "Make your storefront stand out with an eye-catching animated banner! Transform the standard still image into a dynamic, professional video or motion graphic that grabs attention.Perfect for coaches looking to enhance the appeal of their subscription programs and make a strog first impression.",
    whatyouget: [
      "A custom animated banner for your storefront, tailored to your brand’s style",
      "Motion graphics or video that highlights your unique offerings",
      "Delivered in high resolution, optimized for seamless display",
    ],
    timeline: [
      {
        phase: "Submit the requirements and make payment",
        time: "5 mins",
        upTo: "(Client)",
      },
      {
        phase: "Delivery",
        time: "1-3 days",
        upTo: "(MSB)",
      },
    ],
    requirements: [
      "Your logo, brand colors, and any specific style preferences",
    ],
    price: 50,
    img: "/img/services/Animated Banner.gif",
    link: "https://form.typeform.com/to/E7YRhNTl",
  },
  "storefront-redesign": {
    title: "Storefront & App Redesign",
    brief:
      "Boost your program’s potential with a professional redesign of your storefront and app. Quality design plays a crucial role in attracting clients and converting them into subscribers. This service includes a refreshed banner, updated splash screen, and a new custom app mock-up—giving your business a polished, engaging look.",
    whatyouget: [
      "A redesigned storefront banner and splash screen for a cohesive brand experience",
      "One custom app mock-up that showcases your branding and professionalism",
      "Consistent design across all touchpoints to enhance user experience and engagement",
    ],
    timeline: [
      {
        phase: "Submit the requirements and make payment",
        time: "5 mins",
        upTo: "(Client)",
      },
      {
        phase: "Delivery",
        time: "3-5 days",
        upTo: "(MSB)",
      },
    ],
    requirements: [
      "Your logo, brand colors, and any specific images you want incorporated",
    ],
    price: 75,
    img: "/img/services/Storefront-and-App-Redesign.webp",
    link: "https://form.typeform.com/to/cDwwDXF2",
  },
};
